import axios from 'axios'
import {UposlenikModel, Option} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {ParamsModelPrijavaKvara, PrijavaKvaraModel} from '../models/PrijavaKvara'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/prijavaKvara`
const API2 = `${API_URL}/getNerealizovanePrijave`
const API3 = `${API_URL}/getNerealizovanePrijaveDropdown`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

export async function getAllPrijavaKvara(params: ParamsModelPrijavaKvara) {
  return await axios.get<Array<PrijavaKvaraModel>>(API, {headers: headers, params: params})
}
export async function getNerelaziovanePrijavaKvara(params: ParamsModelPrijavaKvara) {
  return await axios.get<Array<PrijavaKvaraModel>>(API2, {headers: headers, params: params})
}

export async function getPrijavaKvaraDropdown() {
  try {
    return await axios.get<Array<Option>>(API3, {headers: headers})
  } catch (error) {
    console.error('Error fetching Prijava Kvara Dropdown data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}
export async function savePrijavaKvara(Data: any) {
  try {
    const response = await axios.post(API, Data, {headers: headers})
    return response.data
  } catch (error) {
    console.error('Error Saving data:', error)
    return error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function fetchPrijavaKvara(Id: number): Promise<Partial<PrijavaKvaraModel>> {
  try {
    const response = await axios.get(`${API}/${Id}`)
    if (response.data && response.data.error === 0) {
      return response.data.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function updatePrijavaKvara(Data: any, id: number) {
  try {
    const response = await axios.post(`${API}/${id}?_method=PATCH`, Data, {headers: headers})
    return response.data
  } catch (error) {
    console.error('Error Updating data:', error)
    return error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function deletePrijavaKvara(Id: number) {
  try {
    const response = await axios.delete(`${API}/${Id}`, {headers: headers})
    return response.data
  } catch (error) {
    console.error('Error deleting data:', error)
    return error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function getSredstvoInfo(params: any) {
  try {
    const response = await axios.get(`${API_URL}/sredstvoInfo`, {headers: headers, params: params})
    return response.data
  } catch (error) {
    console.error('Error SredstvoInfo data:', error)
    return error // Re-throw the error so it can be handled by the caller if necessary
  }
}
export async function getSredstvoIzPrijaveInfo(params: any) {
  try {
    const response = await axios.get(`${API_URL}/sredstvoInfoIzPrijave`, {headers: headers, params: params})
    return response.data
  } catch (error) {
    console.error('Error SredstvoInfo data:', error)
    return error // Re-throw the error so it can be handled by the caller if necessary
  }
}
export async function startPrijavaKvara(Data: any) {
  try {
    const response = await axios.post(`${API_URL}/startPrijavaKvara`, Data, {
      headers: headers,
    })
    return response.data
  } catch (error) {
    console.error('Error Saving data:', error)
    return error // Re-throw the error so it can be handled by the caller if necessary
  }
}
